import React from "react";
import "./Header.css";

const Header = ({ isOfferPage }) => {
  isOfferPage = true;
  const logoSrc = isOfferPage
    ? "/assets/img/Group 318.png"
    : "/assets/img/Group 318.png";

  return (
    <header className="header">
      <img src={logoSrc} alt="Digit Money Logo" className="logo-img" />
    </header>
  );
};

export default Header;
